<template>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :custom-filter="customFilter"
    :hide-default-header="true"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
            :style="{'cursor': header.sortKey ? 'pointer':'initial'}"
            @click="toggleSort(header)"
          >
            <span>{{ header.text }}</span>
            <v-chip
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0"
              x-small
              style="width: 16px;padding: 0 4px;"
            >{{sorting[header.sortKey].index}}</v-chip>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'desc'"
              x-small
            >mdi-arrow-down</v-icon>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'asc'"
              x-small
            >mdi-arrow-up</v-icon>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer> -->

        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="`${year} / ${month}`"
              clearable
              label="月份"
              readonly
              v-on="on"
              style="margin-top: 24px;"
            ></v-text-field>
          </template>
          <v-date-picker
            :value="`${year}-${month}`"
            :max="currentYearMonth"
            type="month"
            @change="onDateChanged"
          ></v-date-picker>

        </v-menu>

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <salary-list-item :item="item"
        :key="`item-${item.ID}`" />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import SalaryListItem from "./salary-list-item.vue";
import XMLGenerator from "@/data/excel/xml-generator-salary.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";
import AppDataSetting from '@/data/app-data-setting.js'

export default {
  components: {
    SalaryListItem
  },
  data: () => ({
    isLoading: false,
    dateMenu: false,
    year: 2020,
    month: new Date().getMonth()+1,
    // data table
    dataList: [],
    dataTable: [],
    pageTitle: "薪資",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    search: "",
    // sorting
    sorting: {
      user: {
        order: null,
        index: -1
      },
      department: {
        order: null,
        index: -1
      },
      position: {
        order: null,
        index: -1
      },
      reward: {//當月獎金
        order: null,
        index: -1
      },
      salary: {//當月實發
        order: null,
        index: -1
      }
    },
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    headers() {
      return [
        { text: "姓名", value: "-", showInMobile: true, sortKey: 'user' },
        { text: "部門", value: "-", sortKey: 'department' },
        { text: "職稱", value: "-", sortKey: 'position' },
        { text: "當月績效", value: "-", showInMobile: false },
        { text: "績效紀錄", value: "-", showInMobile: false },
        { text: "當月獎金", value: "-", showInMobile: false, sortKey: 'reward' },
        { text: "實發金額", value: "-", showInMobile: true, sortKey: 'salary' },
        { text: "操作", value: "-", showInMobile: true }
      ];
    },
    currentYearMonth () {
      let now = new Date()
      const dd = n => n < 10 ? '0'+n : n
      return `${now.getFullYear()}-${dd(now.getMonth()+1)}`
    },
    sortings() {
      let arr = [];
      for (let key in this.sorting) {
        if (this.sorting[key].index > 0)
          arr.push({
            key: key,
            order: this.sorting[key].order,
            index: this.sorting[key].index
          });
      }
      arr = arr.sort((o1, o2) => o1.index - o2.index);
      return arr;
    },
    ...mapGetters(["myLevel",
      "userPositions",
      "userDepartments",
      "departments"])
  },
  methods: {
    toggleSort(header) {
      if (!header.sortKey) return;
      if (this.sorting[header.sortKey].index <= 0) {
        this.sorting[header.sortKey].index = this.sortings.length + 1;
        this.sorting[header.sortKey].order = "desc";
      } else if (this.sorting[header.sortKey].order == "desc") {
        this.sorting[header.sortKey].order = "asc";
      } else if (this.sorting[header.sortKey].order == "asc") {
        this.sorting[header.sortKey].index = -1;
        this.sorting[header.sortKey].order = null;
      } else {
        window.console.error(`toggleSort, unknown status`);
      }
      this.reloadDataTable();
    },
    exportExcel() {
      let datas = this.dataTable.filter(
        o => !this.search || this.customFilter('value-whatever', this.search, o)
      );
      let result = XMLGenerator.generate(this, datas);

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-薪資系統-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }
      XLSXSaver.saveAs(result, fileName);
    },
    //不知道要搜尋什麼
    customFilter(value, search, item) {
      return (
        false//item.Name.includes(search) || getProjectFullID(item).includes(search)
      );
    },
    reloadDataTable() {

      const findUserDepartment = userID => {
        let departmentID = (
          this.userDepartments.find(o => o.UserID == userID) || {}
        ).DepartmentID;
        return this.departments.find(o => o.ID == departmentID) || {};
      };

      const sortingFunc = (o1, o2) => {
        var result = 0;
        // 依據 this.sortings 修改排序
        for (let sorting of this.sortings) {
          if (sorting.key == "user") {
            if (sorting.order == "asc") result = o1.UserID - o2.UserID;
            else result = o2.UserID - o1.UserID;
          } else if (sorting.key == "reward") {
            let o1Value = o1.TotalTaskWorkingItemBonus + o1.TotalWorkOrderBonus
            let o2Value = o2.TotalTaskWorkingItemBonus + o2.TotalWorkOrderBonus
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          } else if (sorting.key == "salary") {
            let o1Value = o1.Amount
            let o2Value = o2.Amount
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          } else if (sorting.key == "department") {
            let o1Value = findUserDepartment(o1.UserID).ID
            let o2Value = findUserDepartment(o2.UserID).ID
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          }  else if (sorting.key == "position") {
            let o1Value = AppDataSetting.findUserLevelByUserID(this, o1.UserID)
            let o2Value = AppDataSetting.findUserLevelByUserID(this, o2.UserID)
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          } 
          return result;
        }
      };
      if (this.sortings.length) this.dataList.sort(sortingFunc)
      this.dataTable = this.dataList;
    },
    loadSalary() {
      this.isLoading = true;
      this.$services.salary
        .getByMonth(this, this.year, this.month)
        .then(res => {
          this.$store.state.salary.list = res.data.result || [];
          this.dataList = res.data.result
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onDateChanged(evt) {
      var arr = evt.split("-");
      this.year = parseInt(arr[0]) || 1;
      this.month = parseInt(arr[1]) || 1;
      this.dateMenu = false;
      this.loadSalary();
    }
  },
  created() {
    this.year = new Date().getYear() + 1900;
    this.month = new Date().getMonth() + 1;

    if (this.myLevel < 10) {
      alert("沒有權限");
      this.$router.push({ name: "main" });
      return;
    }
    this.isLoading = true;
    this.$services.prepareDatas(this).then(this.loadSalary);
  }
};
</script>